<button (click)="onClick()" type="button" class="link-button {{placement}}" [attr.aria-expanded]="showMore">
  <sis-icon icon="chevron" [iconClass]="direction"></sis-icon>{{ text }}
</button>
